import React, { useState } from 'react';

import Observer from '@researchgate/react-intersection-observer';

import { CountUpCustom } from '@ui/moleculs/atoms/CountUpCustom';

import { AnimatedImages } from '@ui/moleculs/atoms/AnimatedImage';
import { AnimatedLinks } from '@ui/moleculs/atoms/AnimatedLinks';

import { ReactComponent as Menu1 } from '@assets/images/section-6/menu-1.svg';
import { ReactComponent as Menu2 } from '@assets/images/section-6/menu-2.svg';

import { ReactComponent as Menu1Mob } from '@assets/images/section-6/menu-1-mob.svg';
import { ReactComponent as Menu2Mob } from '@assets/images/section-6/menu-2-mob.svg';
// import { ReactComponent as MenuNumber } from '@assets/images/section-6/menu-number.svg';

import { ReactComponent as Icon1 } from '@assets/images/section-6/icon-1.svg';
import { ReactComponent as Icon2 } from '@assets/images/section-6/icon-2.svg';
import { ReactComponent as Icon3 } from '@assets/images/section-6/icon-3.svg';
import { ReactComponent as Icon4 } from '@assets/images/section-6/icon-4.svg';
import { ReactComponent as Icon5 } from '@assets/images/section-6/icon-5.svg';

import { KeenSlider } from '@ui/moleculs/atoms/KeenSlider';

import Image1 from '@assets/images/section-6/item-1.webp';
import Image2 from '@assets/images/section-6/item-2.webp';
import Image3 from '@assets/images/section-6/item-3.webp';
import Image4 from '@assets/images/section-6/item-4.webp';

import Image1Safari14 from '@assets/images/section-6/item-1-safari-14.png';
import Image2Safari14 from '@assets/images/section-6/item-2-safari-14.png';
import Image3Safari14 from '@assets/images/section-6/item-3-safari-14.png';
import Image4Safari14 from '@assets/images/section-6/item-4-safari-14.png';

import styles from './index.module.css'

type PageProps = {
  scrollDir?: string;
  isDesktopOrLaptop?: any;
  browser: any;
};

const data = [
  {
    id: 1,
    image: Image1,
    imageSafari: Image1Safari14,
    title: 'Экономический аспект',
    body: '<span class="text-blue-default font-bold"> СП-2 сможет обеспечить надежность, стабильность и диверсификацию поставок газа на рынок ЕС, снизит стоимость газа для конечных потребителей благодаря более короткому транспортному маршруту.</span> Маршрут поставок газа через СП-2  почти на 2 тыс. км меньше до территории Германии, чем через ГТС Украины. «Газпром» будет платить за транспортировку фактически сам себе.',
    hover: `Рабочий регулирует трубопроводную арматуру на компрессорной станции ПАО «Газпром» Славянская, отправной точке газопровода «Северный поток-2», в Усть-Луге, Россия, в четверг, 28 января 2021 года. (Фото: Andrey Rudakov/Bloomberg via Getty Image).`
  },
  {
    id: 2, 
    image: Image2,
    imageSafari: Image2Safari14,
    title: 'Экологический аспект',
    body: 'Углеродный след «Северного потока – 2» в 5,6 раза ниже, в том числе за счет уменьшения количества компрессорных станций, чем у украинского маршрута. <span class="text-blue-default font-bold">Газ — один из самых экологичных источник производства электричества, поэтому увеличение его поставок поможет Европе в сокращении выбросов.</span>',
    hover: 'Порт Мукран, 06 января 2021 года, Мекленбург-Передняя Померания, Засниц-Мукран: маяк на пристани, ведущей к входу в порт в порту Мукран на острове Рюген. (Фото: Jens Büttner/picture alliance via Getty Images).'
  },
  {
    id: 3,
    image: Image3,
    imageSafari: Image3Safari14,
    title: 'Технологии будущего',
    body: '<span class="text-blue-default font-bold">Nord Stream 2 AG (оператор газопровода) изучает возможность поставок водорода по СП-2, сообщал исполнительный директор Маттиас Варниг.</span> Как заявлял вице-премьер Александр Новак, Россия ставит перед собой задачу создать экспортоориентированное производство водорода и может занять около 20% на мировых рынках. СП-2 может стать важной транспортной артерией для достижения этой задачи.',
    hover: '29 апреля 2021 года, Мекленбург-Передняя Померания, Любмин: российский журналист фотографирует себя перед станцией скребка газового причала «Северный поток-2». (Фото: Jens Büttner/picture alliance via Getty Images).'
  },
];

export const Page6: React.FC<PageProps> = ({ ...props }) => {
  const [isVisible, setVisible] = useState([false]);
  const { scrollDir, isDesktopOrLaptop, browser } = props;

  const handleChange = (event: any | never, index: number) => {
    const currActive = isVisible[index];
    const updateArr = [ ...isVisible ];
    updateArr[index] = event.isIntersecting || (currActive && scrollDir === 'down')
    setVisible(updateArr);
  };

  const browserName = browser.name.toLowerCase();
  const browserVersion = browser.version.split('.')[0];

  return (
    <Observer
      onChange={event => handleChange(event, 0)}
      root={null}
      rootMargin={isDesktopOrLaptop ? `0% 0% -20%` : `0% 0% 0%`}
    >
      <article
        className={`
          ${isVisible[0] ? styles.active : ``}
          ${styles.section}
          relative
          max-w-1100
          w-full
          mx-auto
          text-white
          mb-25
        `}
      >
        <header
          className={`
            flex
            justify-center
            relative

            -mt-3
            lg:-mt-0

            pb-11
            lg:pb-20
            pl-8
            mr-4
            lg:pl-0
            lg:mr-0

            overflow-hidden
            lg:overflow-visible
          `}
        >
          <h1
            className={`
              inline-flex
              flex-col
              relative
              font-bold
              lg:text-center
              text-4.5xl
              leading-48.5
              lg:text-4.5xl
            `}
          >
            <span
              className={`
                pt-3
                lg:pt-0
                relative
                transform
                duration-500
                transition-all
              `}
            >
              {isDesktopOrLaptop ?
                  <>
                    <Menu1
                      className={`
                        ${styles.menubg1}
                        absolute
                        transform
                        duration-500
                        delay-500
                        transition-all
                        lg:-mt-7
                        lg:-ml-15
                        max-w-full
                        lg:max-w-none
                        h-1/4
                        lg:h-auto
                      `}
                    />
                    <Menu2
                      className={`
                        ${styles.menubg2}
                        absolute
                        lg:-right-8
                        transform
                        duration-500
                        transition-all
                        mt-12
                        lg:mt-6
                        max-w-full
                        lg:max-w-none
                        h-1/6
                        lg:h-auto
                      `}
                    />
                  </>
                :
                  <>
                    <Menu1Mob
                      className={`
                        ${styles.menubg1}
                        absolute
                        transform
                        duration-500
                        delay-500
                        transition-all
                        -mt-3
                        -ml-6
                      `}
                    />
                    <Menu2Mob
                      className={`
                        ${styles.menubg2}
                        absolute
                        lg:-right-8
                        transform
                        duration-500
                        transition-all
                        mt-11
                        -ml-5
                      `}
                    />
                  </>
                }
              <span className={`relative`}><span className={`-ml-6 lg:ml-0`}>«Северный</span> поток-2» <br className={`flex lg:hidden`} />в цифрах</span>
            </span>
          </h1>
        </header>

        <div
          className={`
            flex
            flex-col
            lg:flex-row
            flex-wrap
            justify-center
            items-start
            mx-8
            lg:mx-0
          `}
        >
          <Observer
            onChange={event => handleChange(event, 1)}
            root={null}
            rootMargin={isDesktopOrLaptop ? `0% 0% -20%` : `0% 0% 0%`}
          >
            <div
              className={`
                ${isVisible[1]? `animate-opacity` : ``}

                transform
                opacity-0
                translate-y-full

                flex
                w-full
                lg:w-auto
                lg:flex-33
                justify-center
                
                mb-8
                lg:mb-26vw
              `}
            >
              <div className={`inline-flex w-full lg:w-auto`}>
                <div className={`min-w-30`}>
                  <Icon1
                    className={`
                      ${isVisible[1]? styles['icon-object'] : ``}
                      flex-shrink-0
                      mt-3
                    `}
                  />
                </div>
                <div className={`pl-5`}>
                  <span className={`inline-flex font-bold text-6.5xl leading-4.5-important`}>

                    {isVisible[1]? <CountUpCustom start={120} end={220} delay={0.5} duration={1.5} /> : <>120</>}

                  </span>
                  <p className={`text-sm font-bold text-menu-number`}>
                    атмосфер давления
                    <br />
                    выдерживают трубы
                    <br />
                    для проекта
                  </p>
                </div>
              </div>
            </div>
          </Observer>

          <Observer
            onChange={event => handleChange(event, 2)}
            root={null}
            rootMargin={isDesktopOrLaptop ? `0% 0% -20%` : `0% 0% 0%`}
          >
            <div
              className={`
                ${isVisible[2]? `animate-opacity` : ``}

                transform
                opacity-0
                translate-y-full
                lg:animation-delay-500

                flex
                w-full
                lg:w-auto
                lg:flex-33
                justify-center

                mb-8
                lg:mb-26vw
              `}
            >
              <div className={`inline-flex w-full lg:w-auto`}>
                <div className={`min-w-30`}>
                  <Icon2
                    className={`
                      ${isVisible[2]? styles['icon-object'] : ``}
                      flex-shrink-0
                      mt-3
                    `}
                  />
                </div>
                <div className={`pl-5`}>
                  <span className={`inline-flex font-bold text-6.5xl leading-4.5-important`}>
                  
                    {isVisible[2]? <CountUpCustom start={0} end={55} delay={0.5} duration={1.5} /> : <>0</>}

                  </span>
                  <p className={`text-base lg:text-md font-bold text-menu-number`}>
                    млрд кубических
                    <br />
                    метров в год составляет
                    <br />
                    мощность газопровода 
                  </p>
                </div>
              </div>
            </div>
          </Observer>

          <Observer
            onChange={event => handleChange(event, 3)}
            root={null}
            rootMargin={isDesktopOrLaptop ? `0% 0% -20%` : `0% 0% 0%`}
          >
            <div
              className={`
                ${isVisible[3]? `animate-opacity` : ``}

                transform
                opacity-0
                translate-y-full
                lg:animation-delay-1000

                flex
                w-full
                lg:w-auto
                lg:flex-33
                justify-center

                mb-8
                lg:mb-26vw
              `}
            >
              <div className={`inline-flex w-full lg:w-auto`}>
                <div className={`min-w-30`}>
                  <Icon3
                    className={`
                      ${isVisible[3]? styles['icon-object'] : ``}
                      flex-shrink-0
                      mt-3
                    `}
                  />
                </div>
                <div className={`pl-5`}>
                  <span className={`inline-flex font-bold text-6.5xl leading-4.5-important`}>

                    {isVisible[3]? <CountUpCustom start={50} end={100} delay={0.5} duration={1.5} /> : <>0</>}

                  </span>
                  <p className={`text-base lg:text-md font-bold text-menu-number`}>
                    тысяч 12-метровых труб
                    <br />
                    требуется для одной
                    <br />
                    нитки газопровода
                  </p>
                </div>
              </div>
            </div>
          </Observer>

          <Observer
            onChange={event => handleChange(event, 4)}
            root={null}
            rootMargin={isDesktopOrLaptop ? `0% 0% -20%` : `0% 0% 0%`}
          >
            <div
              className={`
                ${isVisible[4]? `animate-opacity` : ``}

                transform
                opacity-0
                translate-y-full

                flex
                w-full
                lg:w-auto
                lg:flex-33
                justify-center

                mb-16
                lg:mb-22vw
              `}
            >
              <div className={`inline-flex w-full lg:w-auto`}>
                <div className={`min-w-30`}>
                  <Icon4
                    className={`
                      ${isVisible[4]? styles['icon-object'] : ``}
                      flex-shrink-0
                      mt-3
                    `}
                  />
                </div>
                <div className={`pl-5`}>
                  <span className={`inline-flex font-bold text-6.5xl leading-4.5-important`}>

                    {isVisible[4]? <CountUpCustom start={1000} end={1153} delay={0.5} duration={1.5} /> : <>0</>}

                  </span>
                  <p className={`text-base lg:text-md font-bold text-menu-number`}>
                    миллиметра — неизменный
                    <br />
                    внутренний диаметр
                    <br />
                    газопровода
                  </p>
                </div>
              </div>
            </div>
          </Observer>

          <Observer
            onChange={event => handleChange(event, 5)}
            root={null}
            rootMargin={isDesktopOrLaptop ? `0% 0% -20%` : `0% 0% 0%`}
          >
            <div
              className={`
                ${isVisible[5]? `animate-opacity` : ``}

                transform
                opacity-0
                translate-y-full
                lg:animation-delay-500

                flex
                w-full
                lg:w-auto
                lg:flex-33
                justify-center

                mb-16
                lg:mb-22vw
              `}
            >
              <div className={`inline-flex w-full lg:w-auto`}>
                <div className={`min-w-30`}>
                  <Icon5
                    className={`
                      ${isVisible[5]? styles['icon-object'] : ``}
                      flex-shrink-0
                      mt-3
                    `}
                  />
                </div>
                <div className={`pl-5`}>
                  <p className={`text-base lg:text-md font-bold text-menu-number absolute -mt-6`}>
                    Более
                  </p>
                  <span className={`inline-flex font-bold text-6.5xl leading-4.5-important`}>

                    {isVisible[5]? <CountUpCustom start={1000} end={1100} delay={0.5} duration={1.5} /> : <>0</>}

                  </span>
                  <p className={`text-base lg:text-md font-bold text-menu-number`}>
                    компаний из 25 стран были
                    <br />
                    вовлечены в планирование,
                    <br />
                    проектирование и строительство
                    <br />
                    газотранспортной системы
                  </p>
                </div>
              </div>
            </div>
          </Observer>

        </div>

        <Observer
          onChange={event => handleChange(event, 6)}
          root={null}
          rootMargin={isDesktopOrLaptop ? `0% 0% 0%` : `0% 0% 35%`}
        >
          <div
            className={`
              ${isVisible[6]? `animate-opacity` : ``}

              transform
              opacity-0
              translate-y-full
              
              mb-20
              lg:mb-12vw
              
            `}
          >
            <KeenSlider isDesktopOrLaptop={isDesktopOrLaptop}>
              <React.Fragment>
                {data.map((item, index) => 
                  <div
                    key={index}
                    className={`
                      keen-slider__slide
                      number-slide1
                      max-w-890
                      mx-auto
                      mb-15vw
                    `}>
                    <div
                      className={`
                        flex
                        flex-col
                        lg:flex-row
                        w-full
                      `}
                    >
                      <div
                        className={`
                          relative
                          flex-1
                          text-xxs
                          lg:text-sm
                          font-medium
                          leading-6
                          text-white
                          order-2
                          lg:order-1
                          mx-8
                          lg:mx-0
                        `}
                      >
                        <h3
                          className={`
                            uppercase
                            font-bold
                            text-xlxl
                            mb-2
                            lg:mb-3.5vw
                            lg:pl-24
                          `}
                        >
                          {item.title}
                        </h3>
                        <span
                          className={`
                            inline-block
                            relative
                            text-base
                            lg:pl-24
                            indent-sm
                            lg:mr-11.5vw
                          `}
                          dangerouslySetInnerHTML={{ __html: item.body }}
                        />
                      </div>
                      <div
                        className={`
                          flex-1
                          order-1
                          lg:order-2
                          mb-4
                          lg:mb-0
                          flex
                          lg:block
                          justify-center
                        `}
                      >
                        <div
                          className={`
                            relative

                            overflow-hidden
                            lg:overflow-visible
                            ml-8
                            mr-8
                            lg:ml-11.5vw
                            lg:mr-0
                          `}
                        >

                          <AnimatedImages
                            id={`page-6-image-${index}`}
                            href={(browserName === 'safari' && browserVersion < 15) ? item.imageSafari : item.image}
                            body={item.hover}
                            orientation={`inverse`}
                            isDesktopOrLaptop={isDesktopOrLaptop}
                          />

                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </React.Fragment>
            </KeenSlider>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 7)}
          root={null}
          rootMargin={isDesktopOrLaptop ? `0% 0% 0%` : `0% 0% 20%`}
        >
          <div
            className={`
              ${isVisible[7]? `animate-opacity` : ``}

              transform
              opacity-0
              translate-y-full
              relative
              z-3
            `}
          >
            <AnimatedLinks
              id={`page6-link1`}
              className={`transform transition-transform duration-1000 lg:hover:scale-110`}
              title={`Поставили на «поток»: что меняет ввод нового трубопровода для России и Европы`}
              body={`Аналитики оценили последствия запуска «СП-2»`}
              link={`https://iz.ru/1197468/valerii-voronov/postavili-na-potok-chto-meniaet-vvod-novogo-truboprovoda-dlia-rossii-i-evropy`}
              href={(browserName === 'safari' && browserVersion < 15) ? Image4Safari14 : Image4}
              size={`md`}
              isDesktopOrLaptop={isDesktopOrLaptop}
            />
          </div>
        </Observer>

      </article>
    </Observer>
  );
}